<template>
<ty-modal :visible="true" :before-close="handleClose" :fullscreen="isCollapse" width="60%">
	<Create class="mt-3" @created="update"/>
</ty-modal>
</template>

<script>
import Create from '../components/ShopInventoryCreateProductForm'
import { IsCollapseMixin } from '@/mixins/UI';
// import Project from '../../components/Project'
// import axios from 'axios';
export default {
  data() {
    return {
      loading: false,
      page: 1,
      product: null
    }
  },
  mixins : [
		IsCollapseMixin
	],
  components: {
    Create,

  },
  methods: {
		handleClose(){
			this.$router.back();
    },
    update () {
      this.$store.commit("setUpdateInventory");
    },
  },
}
</script>